import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QrDropDownComponent } from './qr-drop-down.component';
import { SvgQrcodeModule } from '../svg-qrcode/svg-qrcode.module';
import { DropDownMenuModule } from '../drop-down-menu/drop-down-menu.module';

@NgModule({
    declarations: [
        QrDropDownComponent
    ],
    imports: [
        CommonModule,
        DropDownMenuModule,
        SvgQrcodeModule
    ],
    exports: [
        QrDropDownComponent
    ]
})
export class QrDropDownModule { }
